import { ProfileFieldAnswer } from "@/domains/profile/models/ProfileFieldAnswer";

export function ProfileData(values) {
    const data = {};

    values.forEach((value) => {
        const { profile_field_id } = value;
        
        data[profile_field_id] = ProfileFieldAnswer(value);
    });

    return data;
}
